import StructuredTextParser from '@app-ila/components/Utility/StructuredTextParser';
import { Box, Flex, Text } from '@chakra-ui/react';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import { render } from 'datocms-structured-text-to-html-string';

/**
 *
 * @param {Object} card
 * @returns
 */
const IlaSectionCard = ({ card, mergeBottom, ...props }) => {
  return (
    <Flex {...props}>
      <Flex
        flexDir={{ base: 'row', md: 'column' }}
        mb={{ base: '24px', md: '0' }}
        alignItems={{ base: 'flex-end', md: 'flex-start' }}
      >
        <Box mb={{ base: '0px', md: '49.16px' }} mr={{ base: '16px', md: '0' }}>
          <LazyLoadImageComponent
            src={card?.thumbnail?.url}
            alt={card?.thumbnail?.alt}
            width="100%"
            minW="68px"
            maxW={{ base: '70px', md: 'auto' }}
          />
        </Box>
        <Text
          maxW={{ base: 152, md: 218 }}
          color="#FFF"
          fontFamily="var(--FedraSansStd-medium)"
          fontSize={{ base: '20px', md: '24px' }}
          fontStyle="normal"
          fontWeight="500"
          lineHeight="26px"
          mb={mergeBottom || '0px'}
          display={{ base: 'contents', md: 'block' }}
        >
          {card?.title}
        </Text>
      </Flex>
      <StructuredTextParser
        color="#D4D4FA"
        fontFamily="var(--FedraSansStd-book)"
        fontSize={{ base: '16px', md: '16px' }}
        fontStyle="normal"
        fontWeight="400"
        lineHeight={{ base: '24px', md: '160%' }}
        str={render(card?.description)}
      />
    </Flex>
  );
};

export default IlaSectionCard;
